import { sanitizeUserHtml } from 'app/shared-components/layout/userHtmlSanitizer';
import 'app/shared-components/util/wysiwygStyles.css'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function DisplayUserHtml({html, className, id, processLinks, variant, maxLines, maxHeight, overflow}) {
   const navigate = useNavigate();
   const useVariant = variant ? variant : "body2";
   const useMaxHeight = maxHeight ? maxHeight : "300px";
   const useOverflow= overflow ? overflow : "hidden";
   let valueClasses= className ? "wysiwyg " + className : "wysiwyg";
   const useHtml= html ? html : undefined;

   const lineClampStyles = maxLines ? {
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
    } : {};
   
   //Set intial value
  useEffect(() => {
    if (useHtml && processLinks) {
       handleProcessLinks();
    }
  }, [useHtml, processLinks]);
  
  useEffect(() => {
    if (useHtml) {
       handleProcessBreaks();
    }
  }, [useHtml]);
  
  function handleProcessLinks(){
    if (!id) return;
    const element = document.getElementById(id);
    if (!element) return;
    const links = element.getElementsByTagName("a");
    
    for (const link of links) {
      const href = link.getAttribute("href");
      if (href && href.startsWith("/")) {
         link.addEventListener("click", (event) => {event.preventDefault(); event.stopPropagation(); navigate(href);}, false); 
      }
    }
  }
  
  function handleProcessBreaks(){
    if (!id) return;
    const element = document.getElementById(id);
    if (!element) return;
    const paras = element.getElementsByTagName("p");
    for (const para of paras) {
      const content = para.textContent;
      if (!content) {
         var lineBreak = document.createElement("br");
         para.parentNode.replaceChild(lineBreak, para);
      }
    }
  }

   
   return (
        <div style={{
            maxHeight: useMaxHeight,
            overflow: useOverflow,
            wordBreak: 'keep-all',
            overflowWrap: 'normal',
            whiteSpace: 'pre-wrap',
            ...lineClampStyles
        }}
          id={id} className={valueClasses}
          variant={useVariant}
          dangerouslySetInnerHTML={{ __html: sanitizeUserHtml(useHtml) }}
        />
   );
}
   

export default DisplayUserHtml;
